import axios from 'axios';

export const usersApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/users`,
    headers: {
        'Content-Type': 'application/json'
    }
})